var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { prepareAnalytics } from './prepare-analytics';
var AnalyticsEventEmitter = /** @class */ (function () {
    function AnalyticsEventEmitter() {
        var _this = this;
        this._initialized = false;
        this._prefix = '';
        this._getAdditionalParams = function () { return ({}); };
        this.init = function (_a) {
            var prefix = _a.prefix, _b = _a.counterId, counterId = _b === void 0 ? 7 : _b;
            prepareAnalytics(window, document, 'script', 'https://a.wb.ru/sdk/sdk.js', 'wba');
            window.wba('init', { counterId: counterId });
            _this._initialized = true;
            if (prefix) {
                _this._prefix = prefix;
            }
            console.log('@analytics init done');
        };
        this.getIsInitialized = function () { return _this._initialized; };
        this._getCustomEvent = function (name) {
            if (_this._prefix) {
                return "".concat(_this._prefix, "-").concat(name);
            }
            return name;
        };
        this.setAdditionalParamsGetter = function (getter) {
            var performanceTag = '[Analytics: additional parameters getter performance]';
            var countTag = '[Analytics: additional parameters getter called times]';
            _this._getAdditionalParams = function () {
                console.time(performanceTag);
                var getterResult = getter();
                console.timeEnd(performanceTag);
                console.count(countTag);
                return getterResult;
            };
        };
        this.sendEvent = function (_a) {
            var name = _a.name, params = _a.params, customEvent = _a.customEvent, projectName = _a.projectName;
            if (!_this._initialized) {
                return;
            }
            var _b = _this._getAdditionalParams(), idSupplier = _b.idSupplier, idUser = _b.idUser, additionalParams = __rest(_b, ["idSupplier", "idUser"]);
            var formattedName = customEvent ? _this._getCustomEvent(name) : name;
            var formattedParams = __assign(__assign({}, params), additionalParams);
            if (idSupplier !== undefined) {
                formattedParams.idSupplier = idSupplier;
            }
            if (idUser !== undefined) {
                formattedParams.idUser = idUser;
            }
            if (projectName !== undefined) {
                formattedParams.projectName = projectName;
            }
            window.wba(formattedName, formattedParams);
        };
    }
    return AnalyticsEventEmitter;
}());
export var analyticsEventEmitter = new AnalyticsEventEmitter();
